(() => {
  if (customElements.get('elia-catalog-card')) return;
  const favoritesKey = 'elia-favorites-v1';
  let favorites = [];
  try { favorites = JSON.parse(localStorage.getItem(favoritesKey) || '[]'); } catch {}
  if (!Array.isArray(favorites)) favorites = [];
  favorites = favorites.filter(x => x && typeof x.title === 'string' && typeof x.url === 'string');
  const make = (tag, text, cls) => { const n = document.createElement(tag); if (text) n.textContent = text; if (cls) n.className = cls; return n; };
  const safeUrl = value => { try { const u = new URL(value, location.href); return ['https:', 'http:', 'file:'].includes(u.protocol) ? u.href : ''; } catch { return ''; } };
  const desktopQuick = window.matchMedia?.('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  let sizeSheet, sheetBody, sheetForm, sheetParent, sheetNext, sheetOpener, previousOverflow;
  function closeSizes() {
    if (!sheetForm) return;
    sheetParent.insertBefore(sheetForm, sheetNext?.parentNode === sheetParent ? sheetNext : null);
    delete sheetForm.eliaQuickOpener;
    sheetForm = null;
    document.body.style.overflow = previousOverflow;
    const opener = sheetOpener; sheetOpener = null;
    opener?.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  }
  function openSizes(card, form, opener) {
    if (!sizeSheet) {
      sizeSheet = make('dialog', '', 'elia-size-sheet');
      sizeSheet.setAttribute('aria-labelledby', 'elia-size-sheet-title');
      const header = make('div', '', 'elia-size-sheet-header');
      const title = make('h2', 'Izaberi veličinu'); title.id = 'elia-size-sheet-title';
      const close = make('button', '×', 'elia-size-sheet-close'); close.type = 'button';
      close.setAttribute('aria-label', 'Zatvori izbor veličine'); close.onclick = () => sizeSheet.close();
      header.append(title, close); sheetBody = make('div', '', 'elia-size-sheet-body');
      sizeSheet.append(header, sheetBody); document.body.append(sizeSheet);
      sizeSheet.addEventListener('close', () => { if(!sizeSheet.open) closeSizes(); });
      sizeSheet.addEventListener('cancel', e => { e.preventDefault(); sizeSheet.close(); });
      sizeSheet.addEventListener('click', e => {
        if(e.target !== sizeSheet) return;
        const r=sizeSheet.getBoundingClientRect();
        if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)sizeSheet.close();
      });
      sizeSheet.addEventListener('elia:quick-added', () => { sizeSheet.close(); closeSizes(); });
    }
    if(sizeSheet.open) { sizeSheet.close(); closeSizes(); }
    sheetForm=form; sheetParent=form.parentNode; sheetNext=form.nextSibling; sheetOpener=opener;
    form.eliaQuickOpener=opener; previousOverflow=document.body.style.overflow;
    sizeSheet.classList.toggle('elia-size-sheet--match',card.classList.contains('elia-match-card'));
    sizeSheet.setAttribute('aria-label', 'Izaberi veličinu: '+card.data.title+' — '+card.color);
    sheetBody.append(form); document.body.style.overflow='hidden';
    opener.setAttribute('aria-expanded','true'); sizeSheet.showModal();
    (form.querySelector('[data-variant]:not([hidden]):not([disabled])') || sizeSheet.querySelector('button')).focus();
  }
  let panel, panelBody, status, previousFocus;
  function persist() {
    try { localStorage.setItem(favoritesKey, JSON.stringify(favorites)); } catch { status.textContent = 'Proizvod je sačuvan za ovaj prikaz. Pregledač ne dozvoljava trajno čuvanje.'; }
    document.querySelectorAll('elia-catalog-card').forEach(card => card.syncFavorite());
    document.querySelectorAll('[data-elia-favorites-count]').forEach(n => n.textContent = favorites.length ? String(favorites.length) : '');
    if (panel?.open) renderFavorites();
  }
  function renderFavorites() {
    panelBody.replaceChildren();
    if (!favorites.length) { panelBody.append(make('p', 'Još nema sačuvanih proizvoda. Dodirni srce na proizvodu koji ti se sviđa.')); return; }
    favorites.forEach(item => {
      const row = make('article', '', 'elia-saved-item'), a = make('a'), img = make('img');
      a.href = safeUrl(item.url); img.src = safeUrl(item.image); img.alt = ''; img.width = 80; img.height = 120;
      a.append(img, make('span', item.title));
      const remove = make('button', 'Ukloni'); remove.type = 'button'; remove.setAttribute('aria-label', 'Ukloni iz omiljenih: ' + item.title);
      remove.onclick = () => { favorites = favorites.filter(x => String(x.id) !== String(item.id)); persist(); (panelBody.querySelector('button') || panel.querySelector('.elia-saved-close')).focus(); };
      row.append(a, remove); panelBody.append(row);
    });
  }
  function setupFavorites() {
    if(window.eliaCatalog&&!document.body.classList.contains('elia-v09'))return;
    if (panel || (!document.querySelector('elia-catalog-card') && !document.querySelector('.elia-women-pdp') && !document.body.classList.contains('elia-v09'))) return;
    panel = make('dialog', '', 'elia-saved-dialog'); panel.setAttribute('aria-labelledby', 'elia-saved-title');
    const h = make('h2', 'Omiljeni proizvodi'); h.id = 'elia-saved-title';
    const close = make('button', '×', 'elia-saved-close'); close.type = 'button'; close.setAttribute('aria-label', 'Zatvori omiljene'); close.onclick = () => panel.close();
    const note = make('p', 'Sačuvano u ovom pregledaču.', 'elia-saved-note'); panelBody = make('div', '', 'elia-saved-list');
    panel.append(close, h, note, panelBody); document.body.append(panel);
    panel.addEventListener('close', () => previousFocus?.focus());
    panel.addEventListener('click', e => { if (e.target === panel) { const r = panel.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) panel.close(); } });
    const tools = document.querySelector('.preview-tools') || document.querySelector('.header__icons');
    if (tools) { const b = make('button', '', 'elia-saved-trigger'); b.type = 'button'; b.setAttribute('aria-label', 'Omiljeni proizvodi'); b.setAttribute('aria-haspopup', 'dialog'); b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21S2 15 2 8.5C2 2.5 9 1 12 6c3-5 10-3.5 10 2.5C22 15 12 21 12 21Z"/></svg><span data-elia-favorites-count aria-hidden="true"></span>'; b.onclick = () => { previousFocus = b; renderFavorites(); panel.showModal(); close.focus(); }; tools.prepend(b); }
    status = make('p', '', 'elia-catalog-status'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); document.body.append(status); persist();
  }
  customElements.define('elia-catalog-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const source = this.querySelector('[data-card-data]');
      if (!source) return;
      try { this.data = JSON.parse(source.textContent); } catch { return; }
      if (!this.colorCards) {
        this.colorCards = new Map();
        this.querySelectorAll('template[data-color-card]').forEach(t => {
          const card = t.content.querySelector('elia-catalog-card');
          if (card) this.colorCards.set(String(t.dataset.colorCard), card.innerHTML);
        });
        this.querySelectorAll('template[data-color-card]').forEach(t => t.remove());
        this.colorCards.set(String(this.data.id), this.innerHTML);
      }
      this.ready = true; this.color = this.data.initialColor;
      this.main = this.querySelector('.elia-catalog-main'); this.originalSrc = this.main?.getAttribute('src'); this.originalSet = this.main?.getAttribute('srcset');
      this.favorite = this.querySelector('.elia-favorite'); this.favorite.hidden = false;
      this.favorite.onclick = () => {
        const exists = favorites.some(x => String(x.id) === String(this.data.id));
        if (exists) favorites = favorites.filter(x => String(x.id) !== String(this.data.id));
        else favorites.push({ id: this.data.id, title: this.data.title, url: this.data.url, image: this.data.image });
        setupFavorites(); persist(); if (status) status.textContent = this.data.title + (exists ? ' je uklonjen iz omiljenih.' : ' je sačuvan u omiljene.');
      };
      const next = this.querySelector('.elia-card-next');
      if (next) { next.hidden = false; next.onclick = () => { const alternate = this.dataset.gallery !== 'alternate'; this.dataset.gallery = alternate ? 'alternate' : 'main'; next.setAttribute('aria-pressed', String(alternate)); next.setAttribute('aria-label', (alternate ? 'Prva fotografija: ' : 'Drugi ugao: ') + this.data.title); }; }
      this.querySelectorAll('[data-color]').forEach(b => b.onclick = () => this.setColor(b.dataset.color));
      this.querySelectorAll('[data-card-product]').forEach(b => {
        if (!this.colorCards.has(b.dataset.cardProduct)) return;
        b.setAttribute('role', 'button');
        b.setAttribute('aria-pressed', String(b.getAttribute('aria-current') === 'true'));
        b.onclick = e => { e.preventDefault(); if (b.getAttribute('aria-current') !== 'true') this.setProduct(b.dataset.cardProduct); };
        b.onkeydown = e => { if (e.key === ' ') { e.preventDefault(); b.click(); } };
      });
      const form = this.querySelector('[data-elia-quick]');
      if (form) {
        const detail=this.querySelector('.elia-card-quick');
        const pointer=desktopQuick, isMatch=this.classList.contains('elia-match-card');
        const summary=detail.querySelector('summary');
        summary.setAttribute('aria-haspopup','dialog'); summary.setAttribute('aria-expanded','false');
        summary.onclick=e=>{if(isMatch||!pointer?.matches){e.preventDefault();detail.open=false;openSizes(this,form,summary)}};
        if(pointer?.matches&&!isMatch)detail.open=true;
        this.onpointerenter=()=>{if(pointer?.matches&&!isMatch)detail.open=true};
        this.onfocusin=()=>{if(pointer?.matches&&!isMatch)detail.open=true};
        form.querySelector('input[name="id"]').disabled = false;
        form.addEventListener('submit', e => {if(e.submitter?.dataset.variant)form.querySelector('input[name="id"]').value=e.submitter.dataset.variant;});
        form.addEventListener('click', e => { const button = e.target.closest('[data-variant]'); if (button && !button.disabled) form.querySelector('input[name="id"]').value = button.dataset.variant; });
        this.onkeydown = e => { if (e.key === 'Escape') { const details = this.querySelector('.elia-card-quick'); details.open = false; details.querySelector('summary').focus(); } };
      }
      this.setColor(this.color); this.syncFavorite();
    }
    setProduct(id) {
      const markup = this.colorCards.get(String(id));
      if (!markup || this.querySelector('[data-busy]')) return;
      this.onpointerenter = this.onfocusin = this.onkeydown = null;
      this.innerHTML = markup;
      this.dataset.productId = String(id);
      delete this.dataset.gallery;
      this.ready = false;
      this.connectedCallback();
      this.querySelector('[data-color][aria-pressed="true"]')?.focus({preventScroll: true});
      if (status) status.textContent = 'Prikazano: ' + this.data.title + ', ' + this.color;
    }
    syncFavorite() {
      if (!this.data) return;
      const active = favorites.some(x => String(x.id) === String(this.data.id));
      this.favorite.setAttribute('aria-pressed', String(active)); this.favorite.setAttribute('aria-label', (active ? 'Ukloni iz omiljenih: ' : 'Sačuvaj: ') + this.data.title);
    }
    setColor(color) {
      this.color = color;
      this.querySelectorAll('[data-color]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === color)));
      const colorBtn = [...this.querySelectorAll('[data-color]')].find(b => b.dataset.color === color);
      this.querySelector('.elia-catalog-color').textContent = (colorBtn && colorBtn.dataset.colorLabel) || (color === this.data.initialColor && this.data.initialColorLabel) || color || '';
      const variants = this.data.variants.filter(v => this.data.colorIndex < 0 || v.options[this.data.colorIndex] === color);
      this.querySelectorAll('[data-variant]').forEach(b => { const v = variants.find(v => String(v.id) === b.dataset.variant); b.hidden = !v; b.disabled = !v?.available; });
      const variant = variants.find(v => v.available) || variants[0];
      if (variant) { const price=this.querySelector('.elia-catalog-price');price.textContent=variant.price;if(variant.compare)price.append(make('s',variant.compare)); }
      if (this.main) {
        delete this.dataset.gallery;
        const own = color === this.data.initialColor;
        const image = (!own && variant?.image) || this.originalSrc;
        this.main.src = image;
        if (!own && variant?.image) this.main.removeAttribute('srcset'); else if (this.originalSet) this.main.setAttribute('srcset', this.originalSet);
        this.dataset.otherColor = String(color !== this.data.initialColor);
        const next = this.querySelector('.elia-card-next'); if (next) { next.hidden = color !== this.data.initialColor; next.setAttribute('aria-pressed', 'false'); }
      }
    }
  });
  setupFavorites();
  desktopQuick?.addEventListener?.('change',()=>{
    if(sizeSheet?.open){sizeSheet.close();closeSizes();}
    document.querySelectorAll('elia-catalog-card .elia-card-quick').forEach(d=>d.open=desktopQuick.matches&&!d.closest('.elia-match-card'));
  });
  window.addEventListener('storage', e => { if (e.key !== favoritesKey) return; try { const value = JSON.parse(e.newValue || '[]'); if (Array.isArray(value)) { favorites = value.filter(x => x && typeof x.title === 'string' && typeof x.url === 'string'); persist(); } } catch {} });
})();
